import { cn } from '@/lib/cn';

interface PictureProps {
  src: string;
  alt: string;
  className?: string;
  imgClassName?: string;
  loading?: 'lazy' | 'eager';
  fetchPriority?: 'high' | 'auto' | 'low';
  width?: number;
  height?: number;
}

const replaceExt = (src: string, ext: string): string => src.replace(/\.(jpe?g|png)$/i, `.${ext}`);

const isPlaceholder = (src: string): boolean =>
  src.includes('/placeholder-') || src.includes('placeholder-');

export function Picture({
  src,
  alt,
  className,
  imgClassName,
  loading = 'lazy',
  fetchPriority = 'auto',
  width,
  height,
}: PictureProps): React.ReactNode {
  if (isPlaceholder(src)) {
    return (
      <div
        className={cn('relative flex items-center justify-center bg-stone/60', className)}
        role="img"
        aria-label={alt}
      >
        <span className="text-xs italic text-mute/80 sm:text-sm">Platzhalter</span>
      </div>
    );
  }

  return (
    <picture className={className}>
      <source srcSet={replaceExt(src, 'avif')} type="image/avif" />
      <source srcSet={replaceExt(src, 'webp')} type="image/webp" />
      <img
        src={src}
        alt={alt}
        loading={loading}
        decoding="async"
        fetchPriority={fetchPriority}
        width={width}
        height={height}
        className={cn('h-full w-full object-cover', imgClassName)}
      />
    </picture>
  );
}
